module.exports = __webpack_public_path__ + "img/web2.37bf9fb2.png";